import CheckoutFormInner from "./CheckoutForm";

const CheckoutForm = () => {
  return <CheckoutFormInner />;
};

export default CheckoutForm;
